export default {
	core: {
		name: "Name",
		size: "Size",
		modified: "Modified",
		actions: "Actions",
		edit: "Edit",
		cut: "Cut",
		remove: "Remove",
		createFolder: "Create Folder",
		create: "Create",
		update: "Update",
		delete: "Delete",
		deleteText: "Are you sure you want to delete this? This action cannot be reverted.",
		deleteSelected: "Delete selected",
		deleteSelectedText: "Are you sure you want to delete the selected items ({count})? This action cannot be reverted.",
		selectedItemsDeleted: "Selected items deleted ({count})",
		selectedItemsNotDeleted: "{failed} of {total} selected items could not be deleted and are still selected",
		selectAll: "Select all",
		selectedOutsideFolder: "{count} of these items are outside the current folder",
		confirmDelete: "Type 'DELETE' to confirm",
		cancel: "Cancel",
		fileDeleted: "File Deleted",
		fileUpdated: "File Updated",
		folderDeleted: "Folder Deleted",
		folderCreated: "Folder Created",
		provider: "Provider",
		privacyLevel: "Privacy Level",
		public: "Public",
		private: "Private",
		fileName: "File Name",
		save: "Save",
		searchFiles: "Search Files",
		searchTemplates: "Search Templates by ID, Name or logical ID",
		dragFilesHereOr: "Drag your files here or",
		selectFiles: "Select Files",
		status: "Status",
		selectMoreFiles: "Select more files",
		upload: "Upload",
		fileTypeError: "File type is not valid",
		fileSizeMustBeUnder: "File size must be under",
		authorizationError: "You are not authorized",
		generalError: "Oops, something went wrong!",
		folder: "Folder",
		file: "File",
		download: "Download",
		selectFile: "Select File",
		noFileSelected: "No File Selected",
		select: "Select",
		fileUpload: "File Upload",
		graphQlQuery: "GraphQl Query",
		showAdvanced: "Show Advanced",
		hideAdvanced: "Hide Advanced",
		customQuery: "Custom query has been selected",
		confirm: "Confirm",
		deselect: "Deselect",
		pleaseSelectImageFile: "Please select an image file",
		noFilesSelected: "No files selected",
		preparingZipDownload: "Preparing zip download",
		zipJobCreationFailed: "Zip job creation failed",
		zipDownloadReady: "Zip download ready",
		zipDownloadFailed: "Zip download failed",
		zipJobTimeout: "Zip job timeout",
		zipJobFailed: "Zip job failed",
		privateImageCannotBeShown:
			"This image is private, so it would not show without login. Make it Public first, or pick an image from the __public folder.",
		publicCopyFailed: "Could not copy the file to the public folder",
		publicCopyRemoveFailed: "Could not remove the file's public copy",
		cannotMoveIntoPublicFolder:
			"Files cannot be moved into the __public folder. Upload the file as Public, or set it to Public in Edit.",
		deletePublicFileWarning:
			"This file is public. Deleting it also deletes its public copy, so links that open without login will stop working.",
		deleteInPublicFolderWarning: "Links that open without login to this item will stop working.",
		uploadedToPublicFolder: "Saved to {destination}",
		uploadedToPublicAndPrivate: "Public files saved to {publicDestination}. Private files saved to {privateDestination}.",
		publicFolderPermissionError: "You do not have permission to write to the __public folder",
	}
}
